import { classNames } from '../../helpers/classNames';
import { Fragment, ReactNode } from 'react';
import psAccessLogoImage from 'url:../../assets/ps-access-logo.svg';
import accountUpdatesLogoImage from 'url:../../assets/account-updates-logo.svg';
import { getMultiClientPlatformConfigForClient } from '../../helpers/multi-client-config.helpers';
import { LogoSchema } from '../../config/multi-client-config.types';

interface Props {
  url?: string;
  logo: ReactNode;
  altText?: string;
  className?: string;
  isPlatform?: boolean;
  customLogoUrl?: string;
  customLogo?: string | ReactNode;
}

export const NavLogos = ({ logo, isPlatform = false, url, className, customLogo, customLogoUrl }: Props) => {
  const config = getMultiClientPlatformConfigForClient();

  if (customLogo) {
    return (
      <div className={classNames('flex h-full items-center justify-center', className)}>
        <a
          href={customLogoUrl || window.env.PLATFORM_URL}
          className="tablet:block mr-[10px] hidden leading-none text-slate-600"
        >
          {typeof customLogo === 'string' ? <img src={customLogo} alt="" className="h-[33px]" /> : customLogo}
        </a>
      </div>
    );
  }

  let logoImage = psAccessLogoImage;
  if (config.logo === LogoSchema.enum.accountUpdates) {
    logoImage = accountUpdatesLogoImage;
  }

  return (
    <div className={classNames('pl-psc-base flex h-full items-center justify-center', className)}>
      {!isPlatform ? (
        <Fragment>
          <a className="tablet:block mr-[10px] hidden leading-none text-slate-600" href={window.env.PLATFORM_URL}>
            <img src={logoImage} alt="" className="h-[33px]" />
          </a>
          <a className="leading-none" href={url}>
            {logo}
          </a>
        </Fragment>
      ) : (
        <a className="leading-none text-slate-600" href={window.env.PLATFORM_URL}>
          <img src={logoImage} className="h-[33px]" alt="" />
        </a>
      )}
    </div>
  );
};
